import React, { useState } from "react";
import { useStoreState } from "easy-peasy";
import { Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/Home";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  appBar: {
    backgroundColor: "rgba(0, 0, 128, 0.8)",
    color: "white"
  },
  navIcon: {
    color: "white"
  },
  iconButton: {
    padding: "0 5px"
  }
}));

const drawerItems = [
  {
    title: "Categories",
    link: "/"
  },
  {
    title: "FAQ",
    link: "/about" // TODO: change this to new faq page
  },
  {
    title: "About",
    link: "/about"
  },
  {
    title: "Settings",
    link: "/settings"
  }
];

const Title = () => {
  const [title, setTitle] = useState("");
  const location = useLocation();
  const classes = useStyles();

  const getHeaderTitle = pathName => {
    if (pathName === "/") {
      return "";
    }
    if (pathName.match(/category\/meta/g)) {
      return "All Items";
    }
    if (pathName.match(/items\/meta/g)) {
      return "All Items";
    }
    if (pathName.match(/items/g)) {
      return "All Categories";
    }
    if (pathName.match(/settings/g)) {
      return "";
    }
  };

  useEffect(() => {
    const { pathname } = location;
    setTitle(getHeaderTitle(pathname));
  }, [location]);

  return <Typography>{title}</Typography>;
};

const HeaderNavLink = () => {
  const categoryId = useStoreState(state => state.app.category);
  const [navLink, setNavLink] = useState("/");
  const [navLinkIcon, setNavLinkIcon] = useState(null);
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();

  const getHeaderNavLink = pathName => {
    if (pathName === "/") {
      return "/";
    }
    if (pathName.match(/category\/meta/g)) {
      if (typeof categoryId !== "string") {
        // is category id not found (reload scenario), goto home
        return "/";
      }
      return `/items/${categoryId}`;
    }
    if (pathName.match(/items\/meta/g)) {
      if (typeof categoryId !== "string") {
        // is category id not found (reload scenario), goto home
        return "/";
      }
      return `/items/${categoryId}`;
    }
    if (pathName.match(/items/g)) {
      return "/";
    }
    if (pathName.match(/settings/g)) {
      return "/";
    }
    if (pathName.match(/about/g)) {
      return "/";
    }
  };

  const getHeaderNavLinkIcon = pathName => {
    if (pathName === "/") {
      return null;
    }
    if (pathName.match(/settings/g)) {
      return <HomeIcon className={classes.navIcon} />;
    }
    if (pathName.match(/about/g)) {
      return <HomeIcon className={classes.navIcon} />;
    }
    return <ArrowBack className={classes.navIcon} />;
  };

  useEffect(() => {
    const { pathname } = location;
    setNavLink(getHeaderNavLink(pathname));
    setNavLinkIcon(getHeaderNavLinkIcon(pathname));
  }, [location]);

  return (
    <IconButton
      edge="end"
      color="primary"
      className={classes.iconButton}
      onClick={() => history.push(navLink)}
    >
      {navLinkIcon}
    </IconButton>
  );
};

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const history = useHistory();
  const classes = useStyles();

  const onDrawerItemClick = link => {
    history.push(link);
    setIsDrawerOpen(false);
  };

  const getDrawerIcon = item => {
    switch (item) {
      case "categories":
        return <FormatListBulletedIcon />;
      case "faq":
        return <QuestionAnswerIcon />;
      case "about":
        return <ContactSupportIcon />;
      case "settings":
        return <SettingsIcon />;
      default:
        return <SettingsIcon />;
    }
  };

  return (
    <React.Fragment>
      <AppBar
        position="static"
        color="transparent"
        className={classes.appBar}
        elevation={1}
      >
        <Toolbar>
          <IconButton edge="start" color="primary">
            <HeaderNavLink />
          </IconButton>
          <Title />
          <div className={classes.grow} />
          <IconButton
            edge="end"
            color="primary"
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          >
            <MenuIcon className={classes.navIcon} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <List>
          {drawerItems.map((item, idx) => (
            <ListItem
              button
              key={idx}
              onClick={() => onDrawerItemClick(item.link)}
            >
              <ListItemIcon>
                {getDrawerIcon(item.title.toLowerCase())}
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </React.Fragment>
  );
};

export default Header;
